import React from "react";

import { useEffect, useState } from "react";
import NewTweetForm from "../components/NewTweetForm/NewTweetForm";
import TweetsList from "../components/TweetsList/TweetsList";
import "./Home.css";
import axios from "axios";

export default function Home({ userName }) {
  const [tweets, setTweets] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const fetchTweets = async () => {
      try {
        const res = await axios.get(
          "https://micro-blogging-dot-full-stack-course-services.ew.r.appspot.com/tweet"
        );
        setTweets(res.data.tweets);
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTweets();
  }, []);

  return (
    <div className="home">
      <div className="main-content">
        <NewTweetForm
          userName={userName}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setTweets={setTweets}
        />
        <TweetsList tweets={tweets} />
      </div>
    </div>
  );
}
